import store from '@/store';

export default {
  create: {
    error: `Sorry, an error occurred adding a feedback, please try again`,
    success: {
      customNotificationConfig: {
        button: {
          onClick: () => window.open(store.state.config.contactSupportLink, '_blank'),
          text: 'Contact us',
        },
      },
      message: `Thanks, your feedback has been received. Need immediate assistance?`,
    },
  },
};
